import { render } from "./Office_Hours.vue?vue&type=template&id=56061056"
import script from "./Office_Hours.vue?vue&type=script&lang=js"
export * from "./Office_Hours.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__